// Broadcast helpers shared by the screens and wa-broadcast: the template's {{n}} variables, what one contact gets,
// and which provider errors are worth another try. The same rules as broadcast_vars / template_var_count in SQL (010).

/** a variable: the contact's first name (text = the word used when there is no name), or the same text for everyone */
export type VarSpec = Record<string, { from: "name" | "text"; text: string }>;

/** the highest {{n}} in a template body (0 = none) */
export function varCount(body: string): number {
  let n = 0;
  for (const m of String(body ?? "").matchAll(/\{\{\s*(\d{1,2})\s*\}\}/g)) n = Math.max(n, Number(m[1]));
  return n;
}

/** the values for one contact */
export function varsFor(spec: VarSpec, name: string | null | undefined): Record<string, string> {
  const first = String(name ?? "").trim().split(/\s+/)[0] ?? "";
  return Object.fromEntries(Object.entries(spec ?? {}).map(([k, v]) => [k, v.from === "name" ? first || v.text : v.text]));
}

/** the text as the contact will read it */
export function fill(body: string, vars: Record<string, string>): string {
  return String(body ?? "").replace(/\{\{\s*(\d{1,2})\s*\}\}/g, (all, k) => vars[k] ?? all);
}

/** worth sending again later: rate limits, the provider's own trouble, the network (not a wrong number or template) */
export function retryable(status: number): boolean {
  return status === 0 || status === 429 || status >= 500;
}
/** minutes to wait before the next try (attempt 1 → 2, 2 → 4) */
export const retryDelayMin = (attempt: number) => 2 ** Math.max(1, attempt);
export const MAX_ATTEMPTS = 3;
